import _readOnlyError from "@babel/runtime/helpers/esm/readOnlyError";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _DeleteStimulusModal;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { Set } from 'immutable';
import { PresentationContent, ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Checkbox } from '@instructure/ui-checkbox';
import { RadioInputGroup, RadioInput } from '@instructure/ui-radio-input';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
import { Modal, ModalHeader, ModalBody, ModalFooter, DELETE_STIMULUS_MODAL_SELECTED_CHILDREN, DELETE_STIMULUS_MODAL_DELETION_MODE, XSMALL_SIDE_MARGIN, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var DeleteStimulusModal = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_DeleteStimulusModal = /*#__PURE__*/function (_Component) {
  function DeleteStimulusModal(props) {
    var _this2;
    _classCallCheck(this, DeleteStimulusModal);
    _this2 = _callSuper(this, DeleteStimulusModal, [props]);
    /**
     * @type {React.RefObject<RadioInput> | null}
     */
    _defineProperty(_this2, "radioInputRef", null);
    _defineProperty(_this2, "handleSubmit", function (e) {
      var _this2$props = _this2.props,
        quizId = _this2$props.quizId,
        stimulusEntry = _this2$props.stimulusEntry,
        childEntries = _this2$props.childEntries;
      if (!_this2.props.deletionMode && childEntries.size > 0) {
        var _this2$radioInputRef;
        (_this2$radioInputRef = _this2.radioInputRef) === null || _this2$radioInputRef === void 0 || (_this2$radioInputRef = _this2$radioInputRef.current) === null || _this2$radioInputRef === void 0 || _this2$radioInputRef.focus();
        _this2.setState({
          validationError: [{
            text: t('Please choose a deletion mode.'),
            type: 'newError'
          }]
        });
        return;
      }
      _this2.closeAction();
      if (_this2.props.deletionMode === 'chooseWhich') {
        _this2.removeStimulus(_this2.props.selectedChildren.toArray());
      } else if (_this2.props.deletionMode === 'deleteAll') {
        _this2.props.removeStimulus(quizId, stimulusEntry, childEntries);
      } else if (_this2.props.deletionMode === 'deleteNone' || childEntries.size === 0) {
        _this2.removeStimulus();
      }
    });
    _defineProperty(_this2, "closeAction", function () {
      _this2.props.closeModal();
      _this2.props.setUi(DELETE_STIMULUS_MODAL_DELETION_MODE, null);
      _this2.props.setUi(DELETE_STIMULUS_MODAL_SELECTED_CHILDREN, Set.of());
      _this2.clearValidationError();
    });
    _defineProperty(_this2, "clearValidationError", function () {
      if (_this2.state.validationError) {
        _this2.setState({
          validationError: null
        });
      }
    });
    _defineProperty(_this2, "setDeletionMode", function (event, value) {
      _this2.clearValidationError();
      _this2.props.setUi(DELETE_STIMULUS_MODAL_DELETION_MODE, value);
    });
    _defineProperty(_this2, "toggleChildSelected", function (childEntry) {
      return function (e) {
        var selectedChildren = _this2.props.selectedChildren;
        var newSelectedChildren = e.target.checked ? selectedChildren.add(childEntry) : selectedChildren["delete"](childEntry);
        _this2.props.setUi(DELETE_STIMULUS_MODAL_SELECTED_CHILDREN, newSelectedChildren);
      };
    });
    _defineProperty(_this2, "renderCheckboxes", function () {
      if (_this2.props.childEntries.size <= 1) {
        return;
      }
      if (_this2.props.deletionMode !== 'chooseWhich') {
        return;
      }
      var checkboxes = _this2.props.childEntries.toArray().map(function (childEntry) {
        var isChecked = _this2.props.selectedChildren.has(childEntry);
        var entry = childEntry.getEntry();
        var itemBody = entry.itemBody;
        if (entry.quizEntry.isBankEntry) {
          itemBody = entry.getEntry().itemBody;
        } else if (entry.quizEntry.isBank) {
          itemBody = t('Item bank: {title}', {
            title: entry.title
          });
        }
        return jsx("div", {
          key: childEntry.id,
          css: _this2.props.styles.checkboxWrapper
        }, jsx(Checkbox, {
          checked: isChecked,
          label: extractTextFromHtml(itemBody),
          onChange: _this2.toggleChildSelected(childEntry),
          value: "true",
          variant: "simple"
        }));
      });
      return jsx("div", {
        key: "checkboxes",
        css: _this2.props.styles.checkboxesWrapper
      }, jsx(PresentationContent, null, jsx("hr", null)), checkboxes, jsx(PresentationContent, null, jsx("hr", null)));
    });
    _this2.state = {
      validationError: null
    };
    _this2.radioInputRef = React.createRef();
    return _this2;
  }
  _inherits(DeleteStimulusModal, _Component);
  return _createClass(DeleteStimulusModal, [{
    key: "confirmRemoveData",
    value: function confirmRemoveData() {
      var numKeepers = this.props.childEntries.size - this.props.selectedChildren.size;
      var text = t('The remaining {numKeepers, plural, =1{item} other{items}} ' + 'will be cloned in order to remove the stimulus association as students ' + 'have already begun to answer {numKeepers, plural, =1{it} other{them}}.', {
        numKeepers: numKeepers
      });
      var title = t('Clone {numKeepers, plural, =1{Item} other{Items}}?', {
        numKeepers: numKeepers
      });
      return {
        title: title,
        text: text,
        continueText: t('Confirm'),
        cancelText: t('Cancel')
      };
    }
  }, {
    key: "isPassage",
    value: function isPassage() {
      var _this$props$stimulusE, _this$props$stimulusE3;
      if (((_this$props$stimulusE = this.props.stimulusEntry) === null || _this$props$stimulusE === void 0 ? void 0 : _this$props$stimulusE.entryType) === 'BankEntry') {
        var _this$props$stimulusE2;
        var bankEntry = (_this$props$stimulusE2 = this.props.stimulusEntry) === null || _this$props$stimulusE2 === void 0 ? void 0 : _this$props$stimulusE2.getEntry();
        var stimulusEntry = bankEntry === null || bankEntry === void 0 ? void 0 : bankEntry.getEntry();
        return stimulusEntry === null || stimulusEntry === void 0 ? void 0 : stimulusEntry.isPassage;
      }
      return (_this$props$stimulusE3 = this.props.stimulusEntry) === null || _this$props$stimulusE3 === void 0 ? void 0 : _this$props$stimulusE3.getEntry().passage;
    }
  }, {
    key: "anyImmutableKeepers",
    value: function anyImmutableKeepers() {
      var keepers = Set(this.props.childEntries).subtract(this.props.selectedChildren);
      return keepers.some(function (keeper) {
        return keeper.isImmutable();
      });
    }
  }, {
    key: "removeStimulus",
    value: function removeStimulus() {
      var childEntriesToDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var _this$props = this.props,
        removeStimulus = _this$props.removeStimulus,
        quizId = _this$props.quizId,
        stimulusEntry = _this$props.stimulusEntry;
      if (this.anyImmutableKeepers()) {
        this.props.withConfirm(partial(removeStimulus, quizId, stimulusEntry, childEntriesToDelete), this.confirmRemoveData());
      } else {
        this.props.removeStimulus(quizId, stimulusEntry, childEntriesToDelete);
      }
    }
  }, {
    key: "cancelButton",
    value: function cancelButton() {
      return jsx(Button, {
        onClick: this.closeAction,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": "sdk-keep-".concat(this.isPassage() ? 'passage' : 'stimulus', "-button")
      }, this.isPassage() ? t('Keep Text Block') : t('Keep Stimulus'));
    }
  }, {
    key: "doneButton",
    value: function doneButton() {
      return jsx(Button, {
        color: "primary",
        onClick: this.handleSubmit,
        margin: XSMALL_SIDE_MARGIN,
        "data-automation": "sdk-remove-".concat(this.isPassage() ? 'passage' : 'stimulus', "-button")
      }, this.isPassage() ? t('Remove Text Block') : t('Remove Stimulus'));
    }
  }, {
    key: "renderChooseWhich",
    value: function renderChooseWhich() {
      if (this.props.childEntries.size <= 1) {
        return;
      }
      return jsx(RadioInput, {
        key: "chooseWhich",
        value: "chooseWhich",
        label: jsx("div", {
          css: this.props.styles.radioSpace
        }, t('Remove stimulus and choose which questions to remove.'), this.renderCheckboxes())
      });
    }
  }, {
    key: "renderMainMenu",
    value: function renderMainMenu() {
      return jsx(RadioInputGroup, {
        name: "deletionMode",
        defaultValue: this.props.deletionMode,
        onChange: this.setDeletionMode,
        description: jsx(ScreenReaderContent, null, t('Stimulus Removal Mode')),
        messages: this.state.validationError
      }, jsx(RadioInput, {
        ref: this.radioInputRef,
        key: "deleteAll",
        value: "deleteAll",
        label: jsx("div", {
          css: this.props.styles.radioSpace
        }, t('Remove stimulus and all attached questions.'))
      }), this.renderChooseWhich(), jsx(RadioInput, {
        key: "deleteNone",
        value: "deleteNone",
        label: jsx("div", {
          css: this.props.styles.radioSpace
        }, t('Remove stimulus only. Questions will be released into assessment.'))
      }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var message = this.isPassage() ? t('Are you sure you want to remove this text block?') : t('Are you sure you want to remove this stimulus?');
      var content = this.props.childEntries.size === 0 ? jsx("span", null, message) : this.renderMainMenu();
      var stimulusTitle = this.props.stimulusEntry && this.props.stimulusEntry.getEntry().title;
      return jsx("div", {
        className: "deleteStimulusModal",
        css: this.props.styles.deleteStimulusModal
      }, jsx("div", {
        css: this.props.styles.deleteStimulusModal.stimulusTitle
      }, stimulusTitle), content);
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Modal, {
        open: this.props.modalOpen,
        onDismiss: this.closeAction,
        size: "small",
        label: this.isPassage() ? t('Confirm Text Block Removal') : t('Confirm Stimulus Removal')
      }, jsx(ModalHeader, null, jsx(Heading, {
        level: "reset",
        as: "h2"
      }, this.isPassage() ? t('Confirm Text Block Removal') : t('Confirm Stimulus Removal')), jsx(CloseButton, {
        onClick: this.closeAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), jsx(ModalBody, null, this.renderContent()), jsx(ModalFooter, null, this.cancelButton(), this.doneButton()));
    }
  }]);
}(Component), _defineProperty(_DeleteStimulusModal, "displayName", 'DeleteStimulusModal'), _defineProperty(_DeleteStimulusModal, "componentId", "Quizzes".concat(_DeleteStimulusModal.displayName)), _defineProperty(_DeleteStimulusModal, "propTypes", {
  childEntries: ImmutablePropTypes.list.isRequired,
  closeModal: PropTypes.func.isRequired,
  deletionMode: PropTypes.string,
  modalOpen: PropTypes.bool.isRequired,
  removeStimulus: PropTypes.func.isRequired,
  selectedChildren: ImmutablePropTypes.set,
  setUi: PropTypes.func.isRequired,
  withConfirm: PropTypes.func.isRequired,
  stimulusEntry: ImmutablePropTypes.record,
  quizId: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_DeleteStimulusModal, "defaultProps", {
  selectedChildren: Set.of(),
  deletionMode: '',
  stimulusEntry: void 0,
  quizId: void 0
}), _DeleteStimulusModal)) || _class);
export default DeleteStimulusModal;